import { Outlet } from "react-router-dom";

export function LoginRoute() {
  return (
    <div className="h-full">
      <Outlet />
    </div>
  );
}

export default LoginRoute;
